import { useMemo, useRef } from "react"
//import clonedeep from "lodash.clonedeep"
import isEqual from "react-fast-compare"


export const useStoredMemo = (value) => {
	const ref = useRef({ current: value, old: undefined })

	const nextValue = useMemo(() => {
		if (isEqual(ref.current.current, value))
			return ref.current.current

		ref.current.old = ref.current.current

		return ref.current.current = value;
	}, [value])

	return [nextValue, ref.current.old];
}
export default useStoredMemo;
